import NoOpAuthorizationProvider from './NoOpAuthorizationProvider';
import SznLoginAuthorizationProvider from './SznLoginAuthorizationProvider';

export default function authorizationTokenProviderFactory(scriptLoadTimeout) {
	const authenticationProvider = getAuthenticationProvider(scriptLoadTimeout);
	let isReady = false;

	return function getAuthorizationToken(callback) {
		if (isReady) {
			authenticationProvider.getAuthorizationToken((error, token) => {
				callback(error, token);
			});

			return;
		}

		authenticationProvider.onReady = () => {
			isReady = true;
			getAuthorizationToken(callback);
		};
	};
}

export function getAuthenticationProvider(scriptLoadTimeout) {
	if (SznLoginAuthorizationProvider.isSupported()) {
		return new SznLoginAuthorizationProvider(scriptLoadTimeout);
	}

	return new NoOpAuthorizationProvider();
}
